import api from './axios';

// Auth
export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  logout: () => api.post('/auth/logout'),
  me: () => api.get('/auth/me'),
};

// Bookings
export const bookingsAPI = {
  getAll: (params) => api.get('/admin/bookings', { params }),
  getByService: (serviceId) => api.get(`/tuyona/bookings/${serviceId}`),
  getOne: (id) => api.get(`/tuyona/bookings/${id}`),
  create: (data) => api.post('/tuyona/bookings', data),
  update: (id, data) => api.put(`/tuyona/bookings/${id}`, data),
  delete: (id) => api.delete(`/tuyona/bookings/${id}`),
};

// Providers
export const providersAPI = {
  getAll: (params) => api.get('/tuyona/providers', { params }),
  getOne: (id) => api.get(`/tuyona/providers/${id}`),
  create: (data) => api.post('/tuyona/providers', data),
  update: (id, data) => api.put(`/tuyona/providers/${id}`, data),
  delete: (id) => api.delete(`/tuyona/providers/${id}`),
};

// Services
export const servicesAPI = {
  getAll: (params) => api.get('/tuyona/services', { params }),
  getPublic: () => api.get('/services'),
  getOne: (id) => api.get(`/tuyona/services/${id}`),
  create: (data) => api.post('/tuyona/services', data),
  update: (id, data) => api.put(`/tuyona/services/${id}`, data),
  delete: (id) => api.delete(`/tuyona/services/${id}`),
};

// Availability Slots
export const availabilitySlotsAPI = {
  getAll: (params) => api.get('/tuyona/availability-slots', { params }),
  getByService: (serviceId) => api.get(`/smenes/${serviceId}`),
};

// Service Types
export const serviceTypesAPI = {
  getAll: (params) => api.get('/tuyona/service-types', { params }),
  getPublic: () => api.get('/types'),
  getOne: (id) => api.get(`/tuyona/service-types/${id}`),
  create: (data) => api.post('/tuyona/service-types', data),
  update: (id, data) => api.put(`/tuyona/service-types/${id}`, data),
  delete: (id) => api.delete(`/tuyona/service-types/${id}`),
};

// Regions
export const regionsAPI = {
  getAll: (params) => api.get('/tuyona/regions', { params }),
  getOne: (id) => api.get(`/tuyona/regions/${id}`),
  create: (data) => api.post('/tuyona/regions', data),
  update: (id, data) => api.put(`/tuyona/regions/${id}`, data),
  delete: (id) => api.delete(`/tuyona/regions/${id}`),
};

// Districts
export const districtsAPI = {
  getAll: (params) => api.get('/tuyona/districts', { params }),
  getOne: (id) => api.get(`/tuyona/districts/${id}`),
  create: (data) => api.post('/tuyona/districts', data),
  update: (id, data) => api.put(`/tuyona/districts/${id}`, data),
  delete: (id) => api.delete(`/tuyona/districts/${id}`),
};

// Payments
export const paymentsAPI = {
  getAll: (params) => api.get('/tuyona/payments', { params }),
  getOne: (id) => api.get(`/tuyona/payments/${id}`),
  create: (data) => api.post('/tuyona/payments', data),
  update: (id, data) => api.put(`/tuyona/payments/${id}`, data),
  delete: (id) => api.delete(`/tuyona/payments/${id}`),
};

// Reviews
export const reviewsAPI = {
  getAll: (params) => api.get('/tuyona/reviews', { params }),
  getOne: (id) => api.get(`/tuyona/reviews/${id}`),
  create: (data) => api.post('/tuyona/reviews', data),
  update: (id, data) => api.put(`/tuyona/reviews/${id}`, data),
  delete: (id) => api.delete(`/tuyona/reviews/${id}`),
};

// Reports (Admin)
export const reportsAPI = {
  getAll: (params) => api.get('/admin/reports', { params }),
  getOne: (id) => api.get(`/admin/reports/${id}`),
  updateStatus: (id, data) => api.patch(`/admin/reports/${id}/status`, data),
  delete: (id) => api.delete(`/admin/reports/${id}`),
};

// Employees
export const employeesAPI = {
  getByProvider: (providerId) => api.get(`/tuyona/employees/${providerId}`),
  getOne: (id) => api.get(`/tuyona/employees/${id}`),
  create: (data) => api.post('/tuyona/employees', data),
  update: (id, data) => api.put(`/tuyona/employees/${id}`, data),
  delete: (id) => api.delete(`/tuyona/employees/${id}`),
  getSalary: (orderId) => api.get(`/tuyona/salary/${orderId}`),
  addSalary: (data) => api.post('/tuyona/employeesalary', data),
  deleteSalary: (id) => api.delete(`/tuyona/salarydel/${id}`),
};

// Xarajatlar (Expenses)
export const expensesAPI = {
  getByOrder: (orderId) => api.get(`/tuyona/xarajat/${orderId}`),
  create: (data) => api.post('/tuyona/xarajat', data),
  delete: (id) => api.delete(`/tuyona/xarajat/${id}`),
};

// Devices
export const devicesAPI = {
  getAll: (params) => api.get('/tuyona/devices', { params }),
  getOne: (id) => api.get(`/tuyona/devices/${id}`),
  delete: (id) => api.delete(`/tuyona/devices/${id}`),
};

// Activity Logs
export const activityLogsAPI = {
  getAll: (params) => api.get('/tuyona/activity-logs', { params }),
};

// Roles
export const rolesAPI = {
  getAll: () => api.get('/roles'),
  create: (data) => api.post('/roles', data),
  update: (id, data) => api.put(`/roles/${id}`, data),
  delete: (id) => api.delete(`/roles/${id}`),
  assign: (data) => api.post('/roles/assign', data),
  remove: (data) => api.post('/roles/remove', data),
};

// Files
export const filesAPI = {
  upload: (formData) => api.post('/files/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
};

// Data
export const dataAPI = {
  getSTData: () => api.get('/stdata'),
  search: (params) => api.get('/search', { params }),
  getProviderData: () => api.get('/tuyona/data/provider'),
  getServiceTypes: () => api.get('/tuyona/data/service-types'),
};
